<template>
		<button class="btn"><slot></slot></button>
</template>

<script>
export default {
	name: "FancyButton"
}
</script>

<style scoped>
.btn {
	padding-left: 25px;
	padding-right: 25px;
	clip-path: polygon(0 0, 95% 0%, 100% 29%, 100% 80%, 100% 100%, 0 100%, 0% 80%, 0% 20%);

	border: none;
	outline: none;
	position: relative;
	z-index: 1;
	background: linear-gradient(to right, #00FFA3, #DC1FFF);
	color: white;
	cursor: pointer;
	animation: gradient 1s ease infinite;
}
.btn::before {
	clip-path: polygon(0 0, 95% 0%, 100% 29%, 100% 80%, 100% 100%, 0 100%, 0% 80%, 0% 20%);

	content: "";
	position: absolute;
	left: 2px;
	right: 2px;
	top: 2px;
	bottom: 2px;
	border-radius: 8px;
	background-color: #080310;
	z-index: -1;
	transition: 200ms
}
.btn::after {
	content: attr(data);
	font-size: 16px;
	background: linear-gradient(to left, #00FFA3, #DC1FFF);
	animation: gradient 1s ease infinite;
	-webkit-background-clip: text;
	color: transparent;
	transition: 200ms
}
</style>